import { useIsEpocusPlatformAdmin } from "../../_lib/rbac/epocus-claim";
import { useCan } from "../../_lib/rbac/use-can";

// TODO(PNE-492): backend seeding + API-level enforcement of these roles; until
// then this gate is a frontend-only guarantee.
export const useCanManageProgramUsers = (): boolean => {
  const canManage = useCan("manageProgramUsers");
  const isPlatformAdmin = useIsEpocusPlatformAdmin();

  return canManage || isPlatformAdmin;
};
